import basicController from "servicestack/basic.controller.properties";
//import addMediaPrompt from 'emun.on-demand/media/add-media-prompt'
//import editMediaPrompt from 'emun.on-demand/media/edit-media-prompt'
import AutoQuery from "servicestack/auto-query/auto-query";
import Media from "webutils/media/media";
import CreateMedia from "webutils/media/create-media";
import modals from "webmodals/modals";

export default class MediaManagerController {
  constructor() {
    basicController(this);
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
    $ctrl.bus = $ctrl.query.bus;
  }

  getAutoQueryOptions() {
    const $ctrl = this;
    return {
      pageSize: 24,
      tagTotalsUrl: "QueryMediaTagTotals.json",
      fields:
        "Id,Label,Description,Tags,Url,CreatedOn,Active,Euid,Realm,ContentType,Height,Width",
      url: `QueryMedia.json`,
      orderBy: "-CreatedOn,Id",
      autoLoad: true,
      append: false,
      hideLeftNav: true,
      navs: [],
      filters: [
        { text: "Search", operation: "" },
        { tag: "Content Type", hidden: true },
        { tag: "Image Type", hidden: true },
      ],
      criteria: Object.assign(
        {
          active: true,
          realm: $ctrl.realm,
        },
        $ctrl.criteria
      ),
      tagCriteria: Object.assign({}, $ctrl.tagCriteria, $ctrl.tags),
      scrub({ data }) {
        data.results = data.results.map((m) => new Media(m));
      },
      sortOptions: {
        Id: "Id: Low to High",
        "-Id": "Id: High to Low",
        Label: "Label: A to Z",
        "-Label": "Label: Z to A",
        ContentLength: "Size: Largest",
        "-ContentLength": "Size: Smallest",
        Description: "Description: A to Z",
        "-Description": "Description: Z to A",
        Rating: "Rating: Low to High",
        "-Rating": "Rating: High to Low",
        "CreatedOn,Id": "Created: Newest",
        "-CreatedOn,Id": "Created: Oldest",
        Active: "Active: A to Z",
        "-Active": "Active: Z to A",
      },
    };
  }

  upload($files) {
    const $ctrl = this;
    if ($files && $files.length) {
      const req = {
        realm: $ctrl.realm,
        tags: $ctrl.query.getTagCriteria(),
      };
      if ($ctrl.realm == "ProductList" && $ctrl.query.results.length > 0) {
        req.ReplacePredecessor = true;
        req.PredecessorId = $ctrl.query.results[0].id;
      }

      return $ctrl.bus
        .upload("CreateMedia.json", {
          request: req,
          files: $files,
        })
        .then(() => $ctrl.query.load(true));
      const cm = ($ctrl.createMedia = new CreateMedia($files, req));
      cm.all.finally(() => ($ctrl.createMedia = !$ctrl.query.load(true)));
    }
  }

  //editMediaInfo(media) {
  //    const $ctrl = this;
  //    return editMediaPrompt({
  //        subTitle: media && media.label,
  //        media
  //    }).then(result => {
  //        if (result) {
  //            if (result.updated) Object.assign(media, result.updated);
  //            if (result.regenerateDesign) $ctrl.regenerateDesign(result.regenerateDesign);
  //            if (result.extendDesign) $ctrl.extendDesign(result.extendDesign);
  //            if (result.publish) $ctrl.publish(result.publish);
  //            if (result.toggleMedia) $ctrl.toggleMedia(result.toggleMedia);
  //        }
  //    });
  //}

  filterStatus(active) {
    const $ctrl = this;
    $ctrl.query.criteria.active = active;
    $ctrl.query.load(true);
  }

  statusLabel(active) {
    return active === true ? "Active" : active === false ? "Inactive" : "All";
  }

  deleteMedia(media) {
    const $ctrl = this;
    return modals.confirm("Delete media", media.label).result.then(() => {
      return $ctrl.bus
        .send("DeleteMedia.json", media)
        .then((res) => $ctrl.query.load(true));
    });
  }

  toggleMedia(m, skip, activated) {
    const $ctrl = this;
    if (activated !== true && activated !== false) activated = !m.active;
    const verb = `${m.active ? "Dea" : "A"}ctivate`;
    const url = `${verb}Media/${m.id}.json`;
    return modals.confirm(`${verb} media`, m.label).result.then(() => {
      m.active = activated;
      m.status = activated ? "Active" : "Inactive";

      $ctrl.bus.send(url).then((res) => {
        Object.assign(m, res.data);
        $ctrl.query.load(true);
      });
    });
  }

  toggleAllMedia(activated) {
    let $ctrl = this;
    $ctrl.query.results.forEach((p) => $ctrl.toggleMedia(p, true, activated));
  }

  addTags() {
    return modals.alert(
      "This feature has not been implemented as of yet.",
      "Under Construction"
    );
  }

  $onDestroy() {
    this.query.dispose();
  }
}
